const surfaceClasses = {
  theme:
    "bg-[url('/assets/images/directordeck-logo-on-light.svg')] " +
    "dark:bg-[url('/assets/images/directordeck-logo-on-dark.svg')]",
  light: "bg-[url('/assets/images/directordeck-logo-on-light.svg')]",
  dark: "bg-[url('/assets/images/directordeck-logo-on-dark.svg')]",
} as const;

const LogoImage: React.FCC<{
  className?: string;
  surface?: 'theme' | 'light' | 'dark';
}> = ({ className, surface = 'theme' }) => {
  return (
    <span
      role="img"
      aria-label="DirectorDeck"
      className={`inline-block aspect-[40/13] shrink-0 bg-contain bg-center bg-no-repeat ${
        surfaceClasses[surface]
      } ${className ?? 'w-[140px] sm:w-[160px]'}`}
    />
  );
};

export default LogoImage;
